import Price from 'components/price';
import { ReactNode } from 'react';
import { FormattedMessage, IntlShape } from 'react-intl';
import { PriceSummaryConfig } from '../types';

interface Args {
  config: Pick<
    PriceSummaryConfig,
    'cheapestShippingMethod' | 'isExistingCustomer' | 'selectedShipping'
  >;
  formatMessage: IntlShape['formatMessage'];
}

interface Result {
  price: number;
  priceContent?: ReactNode;
  title: ReactNode;
}

export const getShippingRowConfig = ({ config, formatMessage }: Args): Result => {
  const hasSelectedPaidShipping = (config.selectedShipping?.price ?? 0) > 0;
  const title = hasSelectedPaidShipping ? (
    formatMessage({ id: 'cart:shipping:costs' })
  ) : (
    <FormattedMessage
      id={
        config.isExistingCustomer ? 'cart:shipping:existing-customer' : 'cart:shipping:new-customer'
      }
      values={{
        span: (text) => (
          <span key="shipping-note" className="text-text-light-bg-secondary">
            {text}
          </span>
        ),
      }}
    />
  );

  if (hasSelectedPaidShipping) {
    return {
      price: config.selectedShipping?.price ?? 0,
      title,
    };
  }

  const price = config.cheapestShippingMethod?.price ?? config.selectedShipping?.price ?? 0;

  return {
    price,
    priceContent:
      price > 0 ? (
        <>
          {formatMessage({ id: 'common:price:from' })} <Price cents value={price} />
        </>
      ) : undefined,
    title,
  };
};
